

import { Pipe, PipeTransform } from '@angular/core';
import { ADDRESS3_LIST } from '@app/config/address.data';

@Pipe({
  name: 'address3Name'
})
export class Address3NamePipe implements PipeTransform {

  transform(value: number): string {

    value = Number(value);

    const ix: number = ADDRESS3_LIST.findIndex(e => +e.id === +value);

    if (ix !== -1)
      return ADDRESS3_LIST[ix].text;

    return '';
  }
}
